var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"focus-point set-marker-container",on:{"click":_vm.handleClick}},[_c('div',{ref:"pin",staticClass:"focus-point-pin set-marker-pin",class:[
      `icon-${_vm.shape}`,
      `is-${_vm.size}`,
      `is-border-${_vm.borderColor}`,
      { 'is-dragging': _vm.isDragging }
    ],style:(_vm.pinStyle),attrs:{"tabindex":"0"},on:{"pointerdown":_vm.handlePointerDown,"keydown":_vm.handleKeyDown,"click":function($event){$event.stopPropagation();}}},[(_vm.isDragging)?_c('div',{staticClass:"coord-tooltip"},[_vm._v(" "+_vm._s(_vm.currentCoordText)+" ")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }